/* src/app/private/components/leads/bulk-upload/bulk-upload.component.scss */
label {
  font-weight: 500;
  margin-bottom: 15px;
}
.sample_down {
  cursor: pointer;
  color: green;
  margin-top: 10px;
  text-decoration: none;
  width: 100%;
  text-align: center;
}
/*# sourceMappingURL=bulk-upload.component.css.map */
